export default "__VITE_ASSET__DtcUo7Hx__"